module.exports = __webpack_public_path__ + "img/remi_ashton.d2e14fa0.jpg";